// Reports API endpoints

import apiClient from './client';

export const reportsAPI = {
  /**
   * Get daily report data
   * @param {Object} params - { start_date, end_date } timestamps
   * @returns {Promise} Daily report data
   */
  getDailyReport: (params) => apiClient.get('/reports/daily', { params }),

  /**
   * Download daily report (Sage export)
   * @param {Object} params - { start_date, end_date } timestamps
   * @returns {Promise} Excel blob
   */
  downloadDailyReport: (params) => apiClient.get('/reports/daily/download', {
    params,
    responseType: 'blob'
  }),

  /**
   * Download visual daily report
   * @param {Object} params - { start_date, end_date } timestamps
   * @returns {Promise} Excel blob
   */
  downloadVisualReport: (params) => apiClient.get('/reports/daily/downloadVisual', {
    params,
    responseType: 'blob'
  }),

  /**
   * Get monthly report data
   * @param {Object} params - { start_date, end_date } timestamps
   * @returns {Promise} Monthly report data
   */
  getMonthlyReport: (params) => apiClient.get('/reports/monthly', { params })
};
